import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';
import SpamOptionStore, { SpamScenarioStore } from './schema/SpamOptionStore';
import { SpamScenarioId } from 'owa-junkmail-configuration';

export const spamOptionStore: SpamOptionStore = {
    spamStores: new ObservableMap<SpamScenarioId, SpamScenarioStore>(),
};

export const getStore = createStore<SpamOptionStore>('sharedSpamStore', spamOptionStore);
export default getStore;
